import SpriteSymbol from "../../../../../../../sfra-webpack-builder/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../sfra-webpack-builder/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "facebook",
  "use": "facebook-usage",
  "viewBox": "0 0 8 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 16\" id=\"facebook\"><path d=\"M5.193 16V8.702h2.36l.352-2.845H5.193V4.042c0-.824.22-1.385 1.357-1.385L8 2.655V.11C7.75.077 6.89 0 5.887 0c-2.09 0-3.521 1.325-3.521 3.76v2.097H0v2.845h2.366V16h2.827Z\" fill=\"#000\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol